import { RISK_GROUPS, RiskKeys } from '@/config';
import { RiskDetails, RiskType } from '@/models';

export default function getRiskTagGroups(
  signalTags: string[],
): Record<string, RiskDetails[]> {
  const groups: Record<string, RiskDetails[]> = {};

  (Object.keys(RISK_GROUPS) as RiskType[]).forEach((riskLevel) => {
    const entries: RiskDetails[] = [];
    const groupSignals = RISK_GROUPS[riskLevel];

    groupSignals.forEach((signalKey) => {
      const present = signalTags.includes(signalKey);

      if (signalKey !== RiskKeys.SANCTIONS && present) {
        entries.push({
          label: signalKey,
          value: 100,
        });
      }
    });

    if (entries.length > 0) {
      groups[riskLevel] = entries;
    }
  });

  return groups;
}
